module.exports = __webpack_public_path__ + "img/title1.46d81a65.png";